module.exports = __webpack_public_path__ + "media/images/checked_box_image-f72f34a215692dfa981ab648bc94e32f.png";